import Vue from 'vue'
import Vuex from 'vuex'
import axios from '@/utils/apiClient'
import yaml from 'js-yaml'
import user from './modules/user'
import auth from './modules/auth'
import constants from '@/data/constants'
import { serverBus } from '../main'
import { AUTH_LOGOUT } from './actions/auth'
import { USER_REQUEST } from './actions/user'
import {
  PROFILE_STORAGE_KEY,
  reconcileAuthSession
} from '@/utils/authStorage'

function dynamicSort(property, property2) {
  // var sortOrder = 1
  if (property[0] === '-') {
    // sortOrder = -1
    property = property.substr(1)
  }
  return function (a, b) {
    // var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
    if (a[property] > b[property]) return 1
    if (a[property] < b[property]) return -1
    if (a[property2] > b[property2]) return 1
    if (a[property2] < b[property2]) return -1
    // return result * sortOrder;
  }
}

function getAge(dateString) {
  var today = new Date()
  var birthDate = new Date(dateString)
  var age = today.getFullYear() - birthDate.getFullYear()
  var m = today.getMonth() - birthDate.getMonth()
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--
  }
  return age
}


function updateArtworkTags(artworkId, tagIds) {
  const url = `${Vue.prototype.$globals.apiserver}/artworks/${artworkId}/update_tags`

  // Prepare the data to be sent in the request
  const data = {
    tag_ids: tagIds
  };

  // Make the API call
  axios.put(url, data)
    .then(response => {
      // Handle success
      console.log('Tags updated successfully', response.data);
      // Optionally, update the Vuex store or local component state
    })
    .catch(error => {
      // Handle error
      console.error('Error updating tags', error);
    });
}

const capitalize = s => {
  if (typeof s !== 'string') return ''
  return s.charAt(0).toUpperCase() + s.slice(1)
}

const toCamel = s => {
  return s.replace(/([-_][a-z])/gi, $1 => {
    return $1
      .toUpperCase()
      .replace('-', '')
      .replace('_', '')
  })
}

const resourceLabels = {
  artworks: 'Artworks',
  artists: 'Artists',
  contacts: 'Contacts',
  exhibitions: 'Exhibitions',
  file_uploads: 'File uploads',
  lists: 'Selections',
  locations: 'Locations',
  packings: 'Packings',
  questions: 'Questions',
  roles: 'Roles',
  support_articles: 'Support articles',
  tag_categories: 'Tag categories',
  tags: 'Tags',
  texts: 'Texts',
  todos: 'Todos',
  users: 'Users'
}

const resourcesLoadedFromServer = [
  'tags',
  'roles',
  'file_uploads',
  'artists',
  'lists',
  'todos',
  'packings',
  'artwork_location_logs',
  'artwork_insurance_logs',
  'locations',
  'exhibitions',
  'contacts',
  'users',
  'support_articles',
  'artworks'
]

const resourcesLoadedFromStorage = ['artists', 'locations']

const readStoredJson = (key) => {
  const value = localStorage.getItem(key)
  if (!value) return null

  try {
    return JSON.parse(value)
  } catch (error) {
    localStorage.removeItem(key)
    return null
  }
}

const resourceLoadError = (section, error) => {
  const responseData = error && error.response && error.response.data
  const responseMessage = responseData && (responseData.error || responseData.message)
  const label = resourceLabels[section] || section

  if (typeof responseMessage === 'string' && responseMessage.length > 0) {
    return `Could not load ${label}: ${responseMessage}`
  }

  return `Could not load ${label}.`
}

const startResourceLoad = (commit, section) => {
  commit('CLEAR_LOAD_ERROR', section)
  commit('SET_LOADING', section)
}

const finishResourceLoad = (commit, section) => {
  commit('UNSET_LOADING', section)
}

const failResourceLoad = (commit, section, error) => {
  commit('SET_LOAD_ERROR', {
    section,
    message: resourceLoadError(section, error)
  })
  console.error(`VUEX: Could not load ${section}`, error)
}
Vue.use(Vuex)
const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  state: {
    sorting: {
      artists: 'sort_name',
      artworks: 'title',
      exhibitions: 'name',
      texts: 'given_filename',
      todos: 'title',
      tags: 'name',
      contacts: 'name'
    },
    searchString: {
      artists: '',
      artworks: '',
      texts: '',
      tags: '',
      todos: '',
      contacts: '',
      locations: '',
      users: '',
      articles: '',
      selections: '',
      exhibitions: ''
    },
    pageNumbers: {
      artists: 1,
      artworks: 1,
      texts: 1,
      tags: 1,
      todos: 1,
      contacts: 1,
      locations: 1,
      users: 1,
      articles: 1,
      selections: 1,
      exhibitions: 1
    },
    showSearch: {
      artists: false,
      artworks: false,
      texts: false,
      tags: false,
      todos: false,
      contacts: false,
      locations: false,
      users: false,
      articles: false,
      selections: false,
      exhibitions: false
    },
    rowsPerPage: {

    },
    // tag_categories: [],
    token: localStorage.getItem('user-token') || '',
    profile: {},
    status: '',
    locations: [],
    packings: [],
    support_articles: [],
    journals: [],
    questions: [],
    todos: [],
    tags: [],
    roles: [],
    view: 'list',
    add_new: false,
    options: false,
    users: [],
    file_uploads: [],
    non_electricals: [],
    lists: [],
    includes: [
      { title: 'Objects', field: 'including_objects' },
      { title: 'Sound', field: 'including_sound' },
      { title: 'Film / Video / AV', field: 'including_film' },
      { title: 'Slide', field: 'including_slide' },
      {
        title: 'Computer Program / Software / File',
        field: 'including_computer'
      },
      { title: 'Performance', field: 'including_performance' },
      { title: 'Light', field: 'including_light' },
      { title: 'Other', field: 'including_other' }
    ],
    currentUser: {},
    // { id: 3, username: 'simone', password: 'simone', avatar: 'simone.png', abb: 'SIM', tabs: ['basic'], allowed_fields: ['title'], allowed_functions: ['download_pdf'] },
    reading_devices: [],
    electricals: [],
    exhibitions: [],
    contacts: [],
    texts: [],
    artworks: [],
    artworks_for_pdf: [],
    artworks_selections: [],
    artwork_location_logs: [],
    artwork_insurance_logs: [],
    links: [],
    // loading: false,
    loading_artworks: false,
    loading_artwork_location_logs: false,
    loading_artwork_insurance_logs: false,
    loading_file_uploads: false,
    loading_roles: false,
    loading_rules: false,
    loading_artists: false,
    loading_contacts: false,
    loading_users: false,
    loading_lists: false,
    loading_locations: false,
    loading_exhibitions: false,
    loading_packings: false,
    loading_texts: false,
    loading_tags: false,
    loading_tag_categories: false,
    loading_todos: false,
    loading_support_articles: false,
    loading_journals: false,
    loading_questions: false,
    load_errors: {},
    // store_date: new Date(),
    selected_columns_for_pdf: [],
    api_server: 'http://api.tb-cms.org',
    currentTab: '',
    artworkColumns: ['Title', 'Accession Number', 'Name', 'Location'],
    filterResults: [],
    currentSelection: [],
    currentListSelection: [],
    currentOutputFieldsSelection: [],
    artists: [],
    collection: [],
    pac_fvh: [],
    pdc_fvh: [],
    pac_mr: [],
    deaccession: [],
    oldMasters: [],
    // user: [],
    limited_user_fields: [],
    user_rights: {
      view_only: {
        artworks_select: 'ownership=1'
      }
    },
    categories: [
      {
        id: 'monitor',
        name: 'Monitor',
        off_icon: 'mdi-monitor',
        on_icon: 'mdi-monitor'
      },
      {
        id: 'projector',
        name: 'Projector',
        off_icon: 'mdi-projector',
        on_icon: 'mdi-projector'
      },
      {
        id: 'motor',
        name: 'Motor',
        off_icon: 'mdi-engine',
        on_icon: 'mdi-engine'
      },
      {
        id: 'bulb',
        name: 'Bulb',
        off_icon: 'mdi-lightbulb',
        on_icon: 'mdi-lightbulb'
      },
      {
        id: 'switch',
        name: 'Switch',
        off_icon: 'mdi-nintendo-switch',
        on_icon: 'mdi-nintendo-switch'
      }
    ],
    filters: []
  },
  mutations: {
    UPDATE_ARTWORK_REPRESENTATIVE_TEXT(state, { artwork_id, representative_text_id }) {
      const artwork = state.artworks.find(a => a.id === artwork_id)
      if (artwork) {
        Vue.set(artwork, 'representative_text_id', representative_text_id)
        Vue.set(artwork, 'has_valid_representative_text', !!representative_text_id)
      }
    },
    UPSERT_ARTWORK_TEXT_SUMMARY(state, { artwork_id, summary }) {
      const artwork = state.artworks.find(a => a.id === artwork_id)
      if (!artwork) return

      const summaries = [...(artwork.artwork_texts || [])]
      const index = summaries.findIndex(text => text.id === summary.id)
      if (index === -1) summaries.push(summary)
      else summaries.splice(index, 1, summary)
      Vue.set(artwork, 'artwork_texts', summaries)
    },
    // call API to regenerate vue image
    GENERATE_DATAURI(state, id) {
      console.log('GENERATE_DATAURI', id)
      axios.get(`${Vue.prototype.$globals.apiserver}/artworks/generate_datauri/${id}`)
        .then(response => {
          console.log('Datauri regenerated successfully', response.data);
        })
        .catch(error => {
          console.error('Error regenerating datauri', error);
        });
    },
    SET_USER_ID(state, user_id) {
      state.user_id = user_id;
    },
    REPLACE_ARTWORK(state, artwork) {
      state.artworks = [
        ...state.artworks.filter(element => element.id !== artwork.id),
        artwork
      ]
    },
    /// item.item, item.table
    REPLACE_OBJECT(state, payload) {
      const table = payload.item.table
      const item = payload.item.item
      const index = state[table].findIndex(element => element.id === item.id)

      if (index === -1) {
        state[table].push(item)
      } else {
        Vue.set(state[table], index, item)
      }
    },
    LOGIN_USER(state, currentUser) {
      state.currentUser = currentUser
    },
    INITIALISE_STORE (state, { session, currentTab, profile }) {
      state.token = session.token
      state.user_id = session.userId
      state.currentTab = currentTab || state.currentTab
      state.profile = profile || {}
    },
    RESTORE_CACHED_RESOURCES (state, resources) {
      Object.keys(resources).forEach(section => {
        state[section] = resources[section]
      })
    },
    [AUTH_LOGOUT] (state) {
      state.token = ''
      state.user_id = null
      state.profile = {}
      state.currentUser = {}
    },
    SET_SORTING: (state, sorting) => {
      // console.log(sorting.sorting)
      if (!!sorting.sorting) {
        // console.log(`Set sorting state of ${sorting.sorting.section} to ${sorting.sorting.column}`)
        // console.log(state.sorting[sorting.sorting.section])
        state.sorting[sorting.sorting.section] = sorting.sorting.column
      } else {
        // console.log('ERROR')
      }
    },
    SET_FILTER: (state, filter) => {
      if (!!filter.ownership) {
        // console.log(filter)
        state.filters[filter.section] = filter.ownership
      } else {
        // console.log('ERROR')
      }
    },
    SET_LOADING: (state, section) => {
      // console.log(`Set loading state of ${section} to true`)
      state[`loading_${section}`] = true
    },
    UNSET_LOADING: (state, section) => {
      // console.log(`Set loading state of ${section} to false`)
      state[`loading_${section}`] = false
    },
    SET_LOAD_ERROR: (state, payload) => {
      Vue.set(state.load_errors, payload.section, payload.message)
    },
    CLEAR_LOAD_ERROR: (state, section) => {
      Vue.delete(state.load_errors, section)
    },
    SAVE_OPTIONS: (state, loading) => {
      // console.log('Set options state to', loading)
      state.options = loading
    },
    ADD_NEW: (state, addNew) => {
      // console.log('Set Add New state to', addNew)
      state.add_new = addNew
    },
    SAVE_SHOW_SEARCH: (state, s) => {
      // console.log('Set showSearch state to', s)
      state.showSearch = s
    },
    SAVE_SEARCH_STRING: (state, s) => {
      // console.log('Set showSearch state to', s)
      state.searchString[s.section] = s.string ? s.string : ''
    },
    SAVE_PAGE_NUMBER: (state, s) => {
      // console.log('Set current page number state to', s)
      state.pageNumbers[s.section] = s.string ? s.string : ''
    },
    SAVE_VIEW: (state, loading) => {
      // console.log('Set view state to', loading)
      state.view = loading
    },
    SET_USER: (state, datas) => {
      // console.log('Set user to', datas)
      state.currentUser = datas
    },
    // UPDATE_USER: (state, datas) => {
    //   console.log('Set user to', datas)
    //   state.currentUser = datas
    //   localStorage.setItem('profile', JSON.stringify(datas))
    //   state.profile = datas
    // },
    SET_COLLECTION: (state, datas) => {
      state.collection = datas
    },
    SET_TAGS: (state, datas) => {
      state.tags = datas
    },
    SET_TAG_CATEGORIES: (state, datas) => {
      state.tag_categories = datas
    },
    SET_TEXTS: (state, datas) => {
      state.texts = datas
    },
    SET_ARTISTS: (state, datas) => {
      state.artists = datas
    },
    SET_LISTS: (state, datas) => {
      for (var index in datas) {
        datas[index].artworks = yaml.load(datas[index].artworks)
        // yaml.load(this.$store.state.lists[0].artworks)
      }
      state.artworks_selections = datas
      state.lists = datas
    },
    SET_TODOS: (state, datas) => {
      state.todos = datas
    },
    ADD_TODO: (state, datas) => {
      // console.log(state.todos)
      state.todos.push(datas)
      // console.log(state.todos)
    },
    TOGGLE_TODO: (state, datas) => {
      var i = state.todos.findIndex(t => t.id === datas.id)
      datas.done = !datas.done
      state.todos.splice(i, 1, datas)
      // console.log('store toggle')
      // console.log(i)
      // state.todos[i].done = !state.todos[i].done
      // state.todos = [
      //   ...state.todos.map(item =>
      //     item.id !== datas.id ? item : { ...item, ...datas }
      //     )
      //   ]
      // console.log(state.todos)
      // state.todos.push(datas)
    },
    SAVE_TODO: (state, datas) => {
      var i = state.todos.findIndex(t => t.id === datas.id)
      // datas.done = !datas.done
      state.todos.splice(i, 1, datas)
      // console.log('store save')
      // console.log(i)
      // state.todos[i].done = !state.todos[i].done
      // state.todos = [
      //   ...state.todos.map(item =>
      //     item.id !== datas.id ? item : { ...item, ...datas }
      //     )
      //   ]
      // console.log(state.todos)
      // state.todos.push(datas)
    },
    ADD_LOG: (state, datas) => {
      state.artwork_location_logs.push(datas)
    },
    UPDATE_LOG: (state, datas) => {
      const index = state.artwork_location_logs.findIndex(log => log.id === datas.id)

      if (index === -1) {
        state.artwork_location_logs.push(datas)
      } else {
        Vue.set(state.artwork_location_logs, index, datas)
      }
    },
    DELETE_LOG: (state, id) => {
      const index = state.artwork_location_logs.findIndex(log => log.id === id)
      if (index !== -1) state.artwork_location_logs.splice(index, 1)
    },
    ADD_INSURANCE_LOG: (state, datas) => {
      state.artwork_insurance_logs.push(datas)
    },
    ADD_CONSERVATION: (state, datas) => {
      let artwork = state.artworks.find(aa => aa.id === datas.artwork_id)
      var i = state.artworks.indexOf(artwork)
      if (i !== -1) {
        if (state.artworks[i].conservations) {
          state.artworks[i].conservations.push(datas)
        } else {
          state.artworks[i].conservations = []
          state.artworks[i].conservations.push(datas)
        }
      }
    },
    ADD_LINK: (state, datas) => {
      state.links.push(datas)
    },
    ADD_TEXT: (state, datas) => {
      state.texts.push(datas)
    },
    ADD_ARTWORK: (state, datas) => {
      state.artworks.push(datas)
    },
    ADD_ARTIST: (state, datas) => {
      state.artists.push(datas)
    },
    ADD_PACKING: (state, datas) => {
      state.packings.push(datas)
    },
    SET_CONTACTS: (state, datas) => {
      state.contacts = datas
    },
    SET_EXHIBITIONS: (state, datas) => {
      state.exhibitions = datas
    },
    ADD_EXHIBITION: (state, datas) => {
      state.exhibitions.push(datas)
    },
    ADD_READING_DEVICE: (state, datas) => {
      state.reading_devices.push(datas)
    },
    ADD_ELECTRICAL: (state, datas) => {
      state.electricals.push(datas)
    },
    ADD_NON_ELECTRICAL: (state, datas) => {
      state.non_electricals.push(datas)
    },
    DELETE_EXHIBITION: (state, datas) => {
      var i = state.exhibitions.indexOf(datas)
      state.exhibitions.splice(i, 1)
    },
    DELETE_DEVICE: (state, datas) => {
      var i = state.devices.indexOf(datas)
      state.devices.splice(i, 1)
    },
    // ADD_EXHIBITION_TO_ARTWORK: (state, datas) => {
    //   var ar = state.exhibitions.find(function (a) { return a.id === datas.exhibition_id })
    //   ar.exhibition_artworks.push()
    //   state.artworks.forEach((a, index) => {
    //     if (a.id === datas.artwork_id) {
    //       Vue.set(state.artworks, index, datas)
    //     }
    //  })
    //   ar.exhibition_artworks.push(datas.id)
    //   state.exhibitions.push(datas)
    // },
    SET_USERS: (state, datas) => {
      Vue.set(state, 'users', datas)
    },
    SET_LOCATIONS: (state, datas) => {
      state.locations = datas
    },
    SET_PACKINGS: (state, datas) => {
      state.packings = datas
    },
    SET_TAGGINGS: (state, datas) => {
      state.taggings = datas
    },
    CREATE_TAG: (state, datas) => {
      state.tags.push(datas)
    },
    DELETE_TAG: (state, datas) => {
      var i = state.tags.indexOf(datas)
      state.tags.splice(i, 1)
    },
    REMOVE_TEXT: (state, datas) => {
      var i = state.texts.indexOf(datas)
      state.texts.splice(i, 1)
    },
    SET_ROLES: (state, datas) => {
      state.roles = datas
    },
    SET_ARTWORKS: (state, datas) => {
      // state.artworks = datas
      Vue.set(state, 'artworks', datas)
    },
    SET_ARTWORK_LOCATION_LOGS: (state, datas) => {
      // state.artworks = datas
      Vue.set(state, 'artwork_location_logs', datas)
    },
    SET_ARTWORK_INSURANCE_LOGS: (state, datas) => {
      // state.artworks = datas
      Vue.set(state, 'artwork_insurance_logs', datas)
    },
    SET_SUPPORT_ARTICLES: (state, datas) => {
      state.support_articles = datas
    },
    SET_JOURNALS: (state, datas) => {
      state.journals = datas
    },
    SET_QUESTIONS: (state, datas) => {
      state.questions = datas
    },
    SET_FILE_UPLOADS: (state, datas) => {
      state.file_uploads = datas
    },
    SET_FILTER_RESULTS: (state, datas) => {
      state.filterResults = datas
    },
    SET_CURRENT_LIST_SELECTION: (state, datas) => {
      state.currentListSelection = datas
    },
    SET_ARTWORKS_FOR_PDF: (state, datas) => {
      state.artworks_for_pdf = datas
    },
    SET_CURRENT_OUTPUT_FIELDS_SELECTION: (state, datas) => {
      state.currentOutputFieldsSelection = datas
    },
    // CURRENT_SELECTION - artworks selected in toolbar
    REMOVE_FROM_CURRENT_SELECTION: (state, datas) => {
      var i = state.currentSelection.indexOf(datas)
      state.currentSelection.splice(i, 1)
    },
    ADD_ARTIST_LINK: (state, link) => {
      // console.log(state.artists)
      let artist = state.artists.find(aa => aa.id === link.artist_id)
      var i = state.artists.indexOf(artist)
      if (i !== -1) {
        if (state.artists[i].artist_links) {
          state.artists[i].artist_links.push(link)
        } else {
          state.artists[i].artist_links = []
          state.artists[i].artist_links.push(link)
        }
        // console.log(state.artists[i])
      }
    },
    DELETE_ARTIST_LINK: (state, link) => {
      // console.log(state.artists)
      let artist = state.artists.find(aa => aa.id === link.artist_id)
      var i = state.artists.indexOf(artist)
      if (i !== -1) {
        if (state.artists[i].artist_links) {
          let li = state.artists[i].artist_links.indexOf(link)
          state.artists[i].artist_links.splice(li)
        }
      }
      // console.log(state.artists[i])
    },
    SET_CURRENT_SELECTION: (state, datas) => {
      state.currentSelection = datas
    },
    ADD_TO_CURRENT_SELECTION: (state, datas) => {
      var tempSelection = Object.assign([], state.currentSelection)
      if (datas) {
        for (var d in datas) {
          if (!tempSelection.includes(datas[d])) {
            tempSelection.push(datas[d])
          }
        }
      }
      // this.$store.dispatch('saveCurrentSelection',temp_selection)
      state.currentSelection = tempSelection
    },
    CLEAR_CURRENT_SELECTION: state => {
      state.currentSelection = []
    },
    CLEAR_CURRENT_SELECTION_LISTS: state => {
      state.currentListSelection = []
    },
    // artwork LISTS - saved artworks selections
    SAVE_CURRENT_SELECTION_TO_USER: (state, datas) => {
      state.artworks_selections.push(datas)
    },
    REMOVE_FROM_SELECTIONS: (state, datas) => {
      var i = state.artworks_selections.indexOf(datas)
      state.artworks_selections.splice(i, 1)
    },
    // NOT FINISHED !!!
    ADD_TO_SELECTION: (state, datas) => {
      var i = state.artworks_selections.indexOf(datas)
      state.artworks_selections.splice(i, 1)
    },
    SET_CURRENT_SELECTION_TAGS: (state, datas) => {
      state.currentSelectionTags = datas
    },
    SET_CURRENT_TAB: (state, datas) => {
      state.currentTab = datas
      localStorage.setItem('currentTab', datas)
    },
    SET_CURRENT_TAB_ARTIST: (state, datas) => {
      state.currentTabArtist = datas
    },
    SET_SELECTED_COLUMNS_FOR_PDF: (state, datas) => {
      state.selected_columns_for_pdf = datas
    },
    REMOVE_ARTWORK_FROM_LIST: (state, datas) => {
      // console.log('store')
      console.log(datas)
      // console.log(datas.a)
      let listindex = state.lists.findIndex(l => l.id === datas.l)
      // console.log(listindex)
      let originalArtworks = state.lists.find(l => l.id === datas.l).artworks
      // console.log(originalArtworks)
      let removedArtworks = originalArtworks.filter(oa => oa !== datas.a)
      // console.log(removedArtworks)
      // console.log(state.lists[listindex].artworks)
      state.lists[listindex].artworks = removedArtworks
      // console.log(state.lists[listindex].artworks)
      let list = state.lists[listindex]

      let list_for_submit = Object.assign({}, state.lists[listindex])
      list_for_submit.artworks = '[' + removedArtworks + ']'

      let url = `${Vue.prototype.$globals.apiserver}/lists/${datas.l}.json`
      axios
        .put(url, list_for_submit)
        .then(response => {
          // console.log(response.data)
          // this.result = response.data
          // this.snackbar = true
        })
        .catch(error => {
          // console.log(error)
        })
    },
    REMOVE_ARTWORK_FROM_EXHIBITION: (state, datas) => {
      // console.log(datas)
      let listindex = state.exhibitions.findIndex(l => l.id === datas.e)
      let originalArtworks = state.exhibitions.find(l => l.id === datas.e)
        .artworks
      let removedArtworks = originalArtworks.filter(oa => oa.id !== datas.a)
      // console.log('originalArtworks')
      // console.log(originalArtworks)
      // console.log('removedArtworks')
      // console.log(state.exhibitions[listindex])
      state.exhibitions[listindex].artworks = removedArtworks
      // console.log(state.exhibitions[listindex])
      let exhibition = state.exhibitions[listindex]

      delete exhibition.artworks
      exhibition.artwork_ids = removedArtworks.map(ea => ea.id)
      exhibition.artworks = exhibition.artwork_ids
      // console.log('exhibition')
      // console.log(exhibition)

      let url = `${Vue.prototype.$globals.apiserver}/exhibitions/${datas.e}.json`
      axios
        .put(url, { exhibition: exhibition })
        .then(response => {
          // console.log(response.data)
          // this.result = response.data
          // this.snackbar = true
        })
        .catch(error => {
          // console.log(error)
        })
    },
    SAVE_HOME_PAGE_TO_USER: (state, datas) => {
      // console.log(state.profile)
      localStorage.setItem('profile', JSON.stringify(datas))
      state.profile = datas
      // console.log(state.profile)
    },
    ADD_ALL_RIGHTS_TO_USER: (state, datas) => {
      const user = state.users.find(u => u.id === datas)
      let rs = state.roles.map(r => r.id)
      user.roles = state.roles
      user.role_ids = rs
      let url = `${Vue.prototype.$globals.apiserver}/users/${user.id}.json`
      axios
        .put(url, { user: user })
        .then(response => { })
        .catch(error => {
          // console.log(error)
        })
    },
    INVERSE_DELETE_RIGHTS: (state, datas) => {
      const user = state.users.find(u => u.id === datas)
      user.delete_rights = !user.delete_rights
      let url = `${Vue.prototype.$globals.apiserver}/users/${user.id}.json`
      axios
        .put(url, { user: user })
        .then(response => { })
        .catch(error => {
          // console.log(error)
        })
    },
    // INVERSE_DISABLE: (state, datas) => {
    // const user = state.users.find(u => u.id === datas)
    // user.enable = user.enable === 'Y' ? 'N' : 'Y'
    // let url = `${Vue.prototype.$globals.apiserver}/users/${user.id}.json`
    // axios
    //   .put(url, { user: user })
    //   .then(response => {
    //     this.dispatch('loadUsers')
    //   })
    //   .catch(error => {
    //     console.log(error)
    //   })
    // },
    REMOVE_ALL_RIGHTS_TO_USER: (state, datas) => {
      const user = state.users.find(u => u.id === datas)
      // let rs = state.roles.map(r => r.id)
      user.roles = []
      user.role_ids = []
      let url = `${Vue.prototype.$globals.apiserver}/users/${user.id}.json`
      axios
        .put(url, { user: user })
        .then(response => { })
        .catch(error => {
          // console.log(error)
        })
    },
    TOGGLE_ADMIN: (state, datas) => {
      const user = state.users.find(u => u.id === datas)
      // console.log(roles)
      if (user.admin === 0 || user.admin === null) {
        user.edit = 1
      } else {
        user.edit = 0
      }
    },
    ADD_TAG_TO_ARTWORKS_IN_CURRENT_SELECTION: (state, { id }) => {
      const tag = state.tags.find(t => t.id === id);
      state.currentSelection.forEach(selectionId => {
        const index = state.artworks.findIndex(a => a.id === selectionId);
        if (index !== -1) {
          const artwork = state.artworks[index];
          const updatedTags = artwork.tags ? [...artwork.tags, tag] : [tag];
          Vue.set(state.artworks, index, { ...artwork, tags: updatedTags });
        }
      });
    },
    ASSIGN_MULTIPLE_TAGS_TO_SELECTION: (state, { tags }) => {
      const artworksToUpdate = state.currentSelection.map(selectionId => 
        state.artworks.find(a => a.id === selectionId)
      );
  
      artworksToUpdate.forEach(artwork => {
        if (artwork) {
          // Deduplicate and add new tags
          const newTags = tags.filter(tag => !artwork.tags.some(t => t.id === tag.id));
          const updatedTags = [...artwork.tags, ...newTags];
          Vue.set(artwork, 'tags', updatedTags);
        }
      });
    },
  
    ADD_TAG_TO_CURRENT_SELECTION: (state, tag) => {
      state.currentSelection.forEach(selectionId => {
        const artwork = state.artworks.find(a => a.id === selectionId);
        if (artwork) {
          // Ensure artwork.tags is an array
          if (!artwork.tags) {
            Vue.set(artwork, 'tags', []);
          }
          // Check if the tag is already present
          if (!artwork.tags.some(t => t.id === tag.id)) {
            // Create a new array with the new tag to ensure reactivity
            Vue.set(artwork, 'tags', [...artwork.tags, tag]);
          }
        }
      });
    },
      // ADD_TAG_TO_ARTWORKS_IN_CURRENT_SELECTION: (state, { id }) => {
    //   const tag = state.tags.find(t => t.id === id);
    
    //   // Convert artworks array to a Map for faster access
    //   const artworksMap = new Map(state.artworks.map(artwork => [artwork.id, artwork]));
    
    //   state.currentSelection.forEach(selectionId => {
    //     if (artworksMap.has(selectionId)) {
    //       const artwork = artworksMap.get(selectionId);
    
    //       // Initialize tags array if it doesn't exist
    //       if (!artwork.tags) {
    //         artwork.tags = [];
    //       }
    
    //       // Check if the tag is already in the artwork's tags
    //       if (!artwork.tags.some(existingTag => existingTag.id === tag.id)) {
    //         // Add the tag to the artwork's tags
    //         const updatedTags = [...artwork.tags, tag];
    //         // Update the artwork in the Map
    //         artworksMap.set(selectionId, { ...artwork, tags: updatedTags });
    //       }
    //     }
    //   });
    //   // Convert the Map back to an array and update the state once
    //   Vue.set(state, 'artworks', Array.from(artworksMap.values()));
      
    // },

    // ADD_TAG_TO_ARTWORKS_IN_CURRENT_SELECTION: (state, { id }) => {
    //   const tag = state.tags.find(t => t.id === id);
    //   state.currentSelection.forEach(selectionId => {
    //     const artwork = state.artworks.find(a => a.id === selectionId);
    //     if (artwork) {
    //       artwork.tags = artwork.tags || [];
    //       if (!artwork.tags.includes(tag)) {
    //         artwork.tags.push(tag);
    //       }
    //     }
    //   });
    // },
    
    // ADD_TAG_TO_ARTWORKS_IN_CURRENT_SELECTION: (state, datas) => {
    //   console.log(datas)
    //   console.log(state.currentSelection)
    //   const artworkIds = state.currentSelection;
    //   console.log(artworkIds)
    //   const filteredArtworks = state.artworks.filter((artwork) => artworkIds.includes(artwork.id));
    //   console.log(filteredArtworks.length)
    
    //   for (const artwork of filteredArtworks) {
    //     if (!artwork.tags) {
    //       artwork.tags = [];
    //     }
    //     artwork.tags.push(datas);
    //     console.log(artwork.tags);
    //   }
    //   ADD_TAG_TO_ARTWORKS_IN_CURRENT_SELECTION: (state, datas) => {
    //     const artworkIds = state.currentSelection;
    //     const filteredArtworks = state.artworks.filter((artwork) => artworkIds.includes(artwork.id));
      
    //     for (const artwork of filteredArtworks) {
    //       if (!artwork.tags) {
    //         artwork.tags = [];
    //       }
    //       artwork.tags.push(datas);
    //     }
    //   },
      
      // UPDATE THE SERVER
      // let ts = artwork.tags.map(tag => tag.id)
      // // artwork.tag_ids = ts
      // artwork.tags = ts
      // artwork.save_tags = 1
      // let url = `${Vue.prototype.$globals.apiserver}/artworks/${artwork.id}.json`
      // axios
      //   .put(url, { artwork: artwork, user_id: state.currentUser.id })
      //   .then(response => {
      //     // commit('SAVE_HOME_PAGE_TO_USER', response.data)
      //     // console.log('response.data')
      //     // console.log(response.data)
      //     // console.log(response)
      //     // state.profile = response.data
      //   })
      //   .catch(error => {
      //     // console.log(error)
      //   })
    // },
    
    ADD_TAG_TO_ARTWORKS_IN_CURRENT_SELECTION: (state, id) => {
      // console.log("ADD_TAG_TO_ARTWORKS_IN_CURRENT_SELECTION = id", id)
      // console.log("ADD_TAG_TO_ARTWORKS_IN_CURRENT_SELECTION = state.currentSelection", state.currentSelection)
      // console.log(state.artworks)
      var tag = state.tags.find(t => t.id === id)
      // console.log("ADD_TAG_TO_ARTWORKS_IN_CURRENT_SELECTION = tag", tag)
      for (let csa in state.currentSelection) {
        // console.log("ADD_TAG_TO_ARTWORKS_IN_CURRENT_SELECTION = csa", csa)
        var artwork = state.artworks.find(
          a => state.currentSelection[csa] === a.id
        )
        // console.log("ADD_TAG_TO_ARTWORKS_IN_CURRENT_SELECTION = artwork", artwork)
        if (!artwork.tags) {
          artwork.tags = []
          artwork.tags.push(tag)
        } else {
          artwork.tags.push(tag)
        }
        // console.log("ADD_TAG_TO_ARTWORKS_IN_CURRENT_SELECTION = artwork.tags", artwork.tags)
        // artwork.tags.push(tag)
        // console.log(state.artworks.find(a => state.currentSelection[csa] === a.id))

        // UPDATE THE SERVER
        let ts = artwork.tags.map(tag => tag.id)
        // artwork.tag_ids = ts
        // artwork.tags = ts
        // artwork.save_tags = 1
        let url = `${Vue.prototype.$globals.apiserver}/artworks/${artwork.id}.json`
        axios
          .put(url, { artwork: {tag_ids: ts}, user_id: state.currentUser.id, save_tags: 1 })
          .then(response => {
            // commit('SAVE_HOME_PAGE_TO_USER', response.data)
            // console.log('response.data', response.data)
            // console.log(response)
            // state.profile = response.data
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
    // setAge: (state, payload) => {
    //   const { age, name } = payload
    //   const person = state.people.find(p => p.Name === name)
    //   person.age = age
    // }
    UPDATE_ARTWORK: (state, datas) => {
      state.artworks = [
        ...state.artworks.map(item =>
          item.id !== datas.id ? item : { ...item, ...datas }
        )
      ]
    },
    DELETE_LINK: (state, datas) => {
      axios
        .delete(`${Vue.prototype.$globals.apiserver}/links/${datas.id}.json`, {
          id: datas.id
        })
        .then(response => {
          this.errors = {}
          let artwork = state.artworks.find(aa => aa.id === datas.artwork_id)
          var i = state.artworks.indexOf(artwork)
          if (i !== -1) {
            if (state.artworks[i].links) {
              state.artworks[i].links.splice(i, 1)
            }
          }
        })
    },
    DELETE_PACKING: (state, datas) => {
      axios
        .delete(
          `${Vue.prototype.$globals.apiserver}/artwork_packings/${datas.id}.json`,
          {
            id: datas.id
          }
        )
        .then(response => {
          this.errors = {}
          let artwork = state.artworks.find(aa => aa.id === datas.artwork_id)
          var i = state.artworks.indexOf(artwork)
          if (i !== -1) {
            if (state.artworks[i].artwork_packings) {
              state.artworks[i].artwork_packings.splice(i, 1)
            }
          }
        })
    },
    DELETE_FILE_UPLOAD: (state, datas) => {
      axios
        .delete(
          `${Vue.prototype.$globals.apiserver}/file_uploads/${datas.id}.json`,
          {
            id: datas.id
          }
        )
        .then(response => {
          this.errors = {}
          let artwork = state.artworks.find(aa => aa.id === datas.artwork_id)
          var i = state.artworks.indexOf(artwork)
          if (i !== -1) {
            if (state.artworks[i].file_uploads) {
              state.artworks[i].file_uploads.splice(i, 1)
            }
          }
        })
    },
    DELETE_SELECTION: (state, datas) => {
      // let selection = state.lists.find(s => s.id === datas.id)
      // console.log(selection)
      // console.log(state.lists)
      // var i = state.lists.indexOf(selection)
      // console.log(state.lists.length)
      // console.log(i)
      state.lists = state.lists.filter(l => l.id !== datas.id)
      // if (i !== -1) {
      //   state.lists.splice(i, 1)
      // }
      // console.log(state.lists.length)
    },
    // add selection to exhibition in this.store.exhibitions
    ADD_SELECTION_TO_EXHIBITION: (state, datas) => {
      console_log(datas)
    },
    // DELETE_ITEM: (state, item) => state.items = state.items.filter(t => item.id !== t.id),
    // DELETE_SELECTION_SERVER: (state, datas) => {

    // },
  },
  actions: {
    initialiseStore ({ commit, dispatch }) {
      const session = reconcileAuthSession()
      if (!session) {
        commit(AUTH_LOGOUT)
        return false
      }

      commit('INITIALISE_STORE', {
        session,
        currentTab: localStorage.getItem('currentTab'),
        profile: readStoredJson(PROFILE_STORAGE_KEY)
      })

      return Promise.all([
        dispatch(USER_REQUEST),
        dispatch('loadAll')
      ]).then(() => true).catch(() => false)
    },
    generate_datauri({ commit }, id) {
      commit('GENERATE_DATAURI', id);
    },
    loadAll ({ commit, dispatch, state }) {
      const cachedResources = {}
      resourcesLoadedFromStorage.forEach(section => {
        const value = readStoredJson(section)
        if (value) cachedResources[section] = value
      })
      commit('RESTORE_CACHED_RESOURCES', cachedResources)

      const loads = resourcesLoadedFromServer.reduce((requests, section) => {
        if (!state[`loading_${section}`]) {
          requests.push(dispatch(`load${capitalize(toCamel(section))}`))
        }
        return requests
      }, [])

      return Promise.all(loads)
    },
    setUserId({ commit }, user_id) {
      commit('SET_USER_ID', user_id);
    },
    replaceObject({ commit }, datas) {
      commit('REPLACE_OBJECT', datas)
    },
    replaceArtwork({ commit }, datas) {
      commit('REPLACE_ARTWORK', datas)
    },
    replaceUser({ commit }, datas) {
      commit('REPLACE_USER', datas)
    },
    deleteSelection({ commit }, datas) {
      axios
        .delete(`${Vue.prototype.$globals.apiserver}/lists/${datas.id}.json`, {
          id: datas.id
        })
        .then(response => {
          this.errors = {}
          commit('DELETE_SELECTION', datas)
          // this.dispatch('loadLists')
        })
      // delete_text(t) {
      // console.log(datas)
      // this.artwork.links = this.artwork.links.filter(at => {
      //   return at.id != datas.id
      // })
      // commit('DELETE_SELECTION_SERVER', datas)
      // .catch(error => { console.log(error) })
    },
    deletePacking({ commit, state }, datas) {
      // delete_text(t) {
      // console.log(datas)
      // this.artwork.links = this.artwork.links.filter(at => {
      //   return at.id != datas.id
      // })
      commit('DELETE_PACKING', datas)
      // .catch(error => { console.log(error) })
    },
    deleteFileUpload({ commit, state }, datas) {
      // delete_text(t) {
      // console.log(datas)
      // this.artwork.links = this.artwork.links.filter(at => {
      //   return at.id != datas.id
      // })
      commit('DELETE_FILE_UPLOAD', datas)
      // .catch(error => { console.log(error) })
    },
    deleteLink({ commit, state }, datas) {
      // delete_text(t) {
      // console.log(datas)
      // this.artwork.links = this.artwork.links.filter(at => {
      //   return at.id != datas.id
      // })
      commit('DELETE_LINK', datas)
      // .catch(error => { console.log(error) })
    },
    addSelectionToExhibition({ commit, state }, datas) {
      console.log(datas)
      // commit('ADD_SELECTION_TO_EXHIBITION', datas)
      let url = `${Vue.prototype.$globals.apiserver}/exhibitions/${datas.id}/add_artworks`
      // let url = `${Vue.prototype.$globals.apiserver}/exhibitions/${datas.id}/selections.json`
      axios
        .post(url, { artwork_ids: state.currentSelection })
        .then(response => {
          this.result = response.data
          // commit('ADD_SELECTION_TO_EXHIBITION', response.data)
          this.dispatch('loadExhibitions')
        })
        .catch(error => {
          // console.log(error)
        })
    },
    updateArtwork({ commit, state }, datas) {
      let url = `${Vue.prototype.$globals.apiserver}/artworks/${datas}.json`
      axios
        .get(url)
        .then(response => {
          this.result = response.data
          commit('UPDATE_ARTWORK', response.data)
        })
        .catch(error => {
          // console.log(error)
        })
    },
    saveTodo({ commit, state }, datas) {
      commit('SAVE_TODO', datas)
    },
    toggleTodo({ commit, state }, datas) {
      commit('TOGGLE_TODO', datas)
    },
    // addAllRights ({ commit, state }, user) {
    //   user.roles = state.roles
    //   var new_user = state.users.find(u => u.id === user.id)
    //   state.users
    // },
    assignMultipleTagsToCurrentSelection({ commit }, selectedTags) {
      commit('ASSIGN_MULTIPLE_TAGS_TO_SELECTION', { tags: selectedTags });
      // Add your API call logic here if necessary
    },
  
    // SHOULD NOT BE USED, SEE FUNCTION BELOW 
    addTagsToCurrentSelection({ commit, state }, selectedTags) {
      // Process each tag and artwork only once
      selectedTags.forEach(tag => {
        commit('ADD_TAG_TO_CURRENT_SELECTION', tag);
      });

      // Make the API call to update the backend after processing all tags
      // Assume updateArtworkTags is an API call function you've defined
      // const updatedArtworks = state.currentSelection.map(selectionId => 
      //   state.artworks.find(artwork => artwork.id === selectionId)
      // );
      // updatedArtworks.forEach(artwork => {
      //   const tagIds = artwork.tags.map(tag => tag.id);
      //   updateArtworkTags(artwork.id, tagIds);
      // });
    },
  
    // add tag with given id to current selection of artworks
    //  if given argument is integer, add tag with that id
    //  if given argument is an array, add tags with those ids
    addTagToCurrentSelection({ commit, state }, datas) {
      console.log(
        "datas",
        datas
      )
      // if (Array.isArray(datas)) {
      //   datas.forEach(tagId => {
      //     commit('ADD_TAG_TO_ARTWORKS_IN_CURRENT_SELECTION', tagId);
      //   });
      //   return;
      // }

      commit('ADD_TAG_TO_ARTWORKS_IN_CURRENT_SELECTION', datas)
      // const artwork = this.$store.state.artworks.find(a => a.id === datas.artwork_id);
      // const tagIds = artwork.tags.map(tag => tag.id);

      // updateArtworkTags(artwork.id, tagIds);

    },
    saveHomePage({ commit, state }, path) {
      var p = state.profile
      // console.log('p')
      // console.log(p)
      // console.log(state.profile)
      let url = `${Vue.prototype.$globals.apiserver}/users/${p.id}.json`
      axios
        .put(url, { user: { after_login_page: path } })
        .then(response => {
          commit('SAVE_HOME_PAGE_TO_USER', response.data)
          // console.log('response.data')
          // console.log(response.data)
          // console.log(response)
          // state.profile = response.data
          this.dispatch('loadUsers')
        })
        .catch(error => {
          // console.log(error)
        })
    },
    loadUser({ commit }, currentUser) {
      commit('LOGIN_USER', currentUser)
    },
    addAllRolesToUser({ commit, state }, datas) {
      commit('ADD_ALL_RIGHTS_TO_USER', datas)
      this.dispatch('loadUsers')
    },
    inverseDeleteRights({ commit, state }, datas) {
      commit('INVERSE_DELETE_RIGHTS', datas)
      this.dispatch('loadUsers')
    },
    inverseDisable({ commit, state }, datas) {
      var u = Object.assign(
        {},
        state.users.find(u => u.id === datas)
      )
      u.enable = u.enable === 'Y' ? 'N' : 'Y'
      let url = `${Vue.prototype.$globals.apiserver}/users/${u.id}.json`
      axios
        .put(url, { user: u })
        .then(response => {
          this.dispatch('loadUsers')
        })
        .catch(error => {
          // console.log(error)
        })
      // commit('INVERSE_DISABLE', datas)
    },
    removeAllRolesFromUser({ commit, state }, datas) {
      commit('REMOVE_ALL_RIGHTS_TO_USER', datas)
      this.dispatch('loadUsers')
    },
    saveOptions({ commit, state }, datas) {
      commit('SAVE_OPTIONS', datas)
    },
    addNew({ commit, state }, datas) {
      commit('ADD_NEW', datas)
    },
    setShowSearch({ commit, state }, datas) {
      commit('SAVE_SHOW_SEARCH', datas)
    },
    setSearchString({ commit, state }, datas) {
      commit('SAVE_SEARCH_STRING', datas)
    },
    setPageNumber({ commit, state }, datas) {
      commit('SAVE_PAGE_NUMBER', datas)
    },
    saveView({ commit, state }, datas) {
      commit('SAVE_VIEW', datas)
    },
    setCurrentUser({ commit, state }, datas) {
      commit('SET_USER', datas)
    },
    // updateUser({ commit, state }, datas) {
    //   commit('UPDATE_USER', datas)
    // },
    saveArtists({ commit, state }, datas) {
      commit('SET_ARTISTS', datas)
    },
    createTag({ commit, state }, datas) {
      commit('CREATE_TAG', datas)
    },
    deleteTag({ commit, state }, datas) {
      // console.log(datas)
      commit('DELETE_TAG', datas)
    },
    postFilterResults({ commit, state }, datas) {
      commit('SET_FILTER_RESULTS', datas)
    },

    // CURRENT SELECTION
    addToCurrentSelection({ commit, state }, datas) {
      commit('ADD_TO_CURRENT_SELECTION', datas)
    },
    saveCurrentSelection({ commit, state }, datas) {
      commit('SET_CURRENT_SELECTION', datas)
    },
    clearCurrentSelection({ commit }) {
      commit('CLEAR_CURRENT_SELECTION')
    },
    clearCurrentSelectionLists({ commit }) {
      commit('CLEAR_CURRENT_SELECTION_LISTS')
    },
    removeFromCurrentSelection({ commit, state }, datas) {
      commit('REMOVE_FROM_CURRENT_SELECTION', datas)
    },
    saveCurrentListSelection({ commit, state }, datas) {
      commit('SET_CURRENT_LIST_SELECTION', datas)
    },

    // LISTS / SELECTION
    removeArtworkFromList({ commit, state }, datas) {
      commit('REMOVE_ARTWORK_FROM_LIST', datas)
    },
    removeArtworkFromExhibition({ commit, state }, datas) {
      commit('REMOVE_ARTWORK_FROM_EXHIBITION', datas)
      this.dispatch('loadExhibitions')
    },

    // PDF
    saveArtworksForPdf({ commit, state }, datas) {
      commit('SET_ARTWORKS_FOR_PDF', datas)
    },
    saveCurrentOutputFieldsSelection({ commit, state }, datas) {
      commit('SET_CURRENT_OUTPUT_FIELDS_SELECTION', datas)
    },
    saveCurrentSelectionToUser({ commit, state }, datas) {
      commit('SAVE_CURRENT_SELECTION_TO_USER', datas)
    },
    removeFromSelections({ commit, state }, datas) {
      commit('REMOVE_FROM_SELECTIONS', datas)
    },
    saveCurrentSelectionTags({ commit, state }, datas) {
      commit('SET_CURRENT_SELECTION_TAGS', datas)
    },
    saveCurrentTab({ commit, state }, datas) {
      commit('SET_CURRENT_TAB', datas)
    },
    saveCurrentTabArtist({ commit, state }, datas) {
      commit('SET_CURRENT_TAB_ARTIST', datas)
    },
    saveSelectedColumnsForPdf({ commit, state }, datas) {
      commit('SET_SELECTED_COLUMNS_FOR_PDF', datas)
    },
    addTodo({ commit, state }, datas) {
      commit('ADD_TODO', datas)
    },
    addLog({ commit, state }, datas) {
      commit('ADD_LOG', datas)
    },
    addLink({ commit, state }, datas) {
      commit('ADD_LINK', datas)
    },
    addArtistLink({ commit, state }, datas) {
      commit('ADD_ARTIST_LINK', datas)
    },
    deleteArtistLink({ commit, state }, datas) {
      commit('DELETE_ARTIST_LINK', datas)
    },
    addText({ commit, state }, datas) {
      commit('ADD_TEXT', datas)
    },
    addPacking({ commit, state }, datas) {
      commit('ADD_PACKING', datas)
    },
    addExhibition({ commit, state }, datas) {
      commit('ADD_EXHIBITION', datas)
    },
    addReadingDevice({ commit, state }, datas) {
      commit('ADD_READING_DEVICE', datas)
    },
    addElectrical({ commit, state }, datas) {
      commit('ADD_ELECTRICAL', datas)
    },
    deleteExhibition({ commit, state }, datas) {
      commit('DELETE_EXHIBITION', datas)
      let url = `${Vue.prototype.$globals.apiserver}/exhibitions/${datas.id}.json`
      axios
        .delete(url, datas)
        .then(response => {
          this.getExhibitions
          serverBus.$emit(
            'showSnackbar',
            'Exhibition deleted.',
            'rgba(0, 125, 0, 0.8)'
          )

        })
        .catch(error => {
          serverBus.$emit(
            'showSnackbar',
            'Error occuredd while deleting Exhibition.',
            'rgba(125, 0, 0, 0.8)'
          )
          console.log(error)
        })

    },
    deleteDevice({ commit, state }, datas) {
      commit('DELETE_DEVICE', datas)
    },
    addArtwork({ commit, state }, datas) {
      commit('ADD_ARTWORK', datas)
    },
    addArtist({ commit, state }, datas) {
      commit('ADD_ARTIST', datas)
    },
    removeText({ commit, state }, datas) {
      commit('REMOVE_TEXT', datas)
    },
    setSorting({ commit, state }, datas) {
      commit('SET_SORTING', datas)
    },
    setFilter({ commit, state }, datas) {
      // console.log(datas)
      commit('SET_FILTER', datas)
    },
    loadRoles({ commit }) {
      startResourceLoad(commit, 'roles')
      axios
        .get(`${Vue.prototype.$globals.apiserver}/roles.json`)
        .then(r => r.data)
        .then(Roles => {
          commit('SET_ROLES', Roles)
          // localStorage.setItem('roles', JSON.stringify(Roles))
          // console.log('Roles loaded')
        })
        .catch(error => failResourceLoad(commit, 'roles', error))
        .then(() => finishResourceLoad(commit, 'roles'))
    },
    loadArtworkInsuranceLogs({ commit, state }) {
      // if (localStorage.getItem('user-token')) {
      if (!state.loading_artwork_insurance_logs) {
        startResourceLoad(commit, 'artwork_insurance_logs')
        axios
          .get(`${Vue.prototype.$globals.apiserver}/artwork_insurance_logs.json`)
          .then(r => r.data)
          .then(artwork_insurance_logs => {
            commit('SET_ARTWORK_INSURANCE_LOGS', artwork_insurance_logs)
            // try {
            //   localStorage.setItem('artworks', JSON.stringify(Artworks))
            // } catch (error) {
            //   console.log('VUEX ERROR!!! COULD NOT SAVE ARTWORKS TO LOCAL STORAGE')
            //   console.log(error)
            // }
            console.log('Artwork Insurance Logs loaded')
          })
          .catch(error => failResourceLoad(commit, 'artwork_insurance_logs', error))
          .then(() => finishResourceLoad(commit, 'artwork_insurance_logs'))
      } else {
        console.log('VUEX: ARTWORK Insurance Logs ALREADY LOADING')
      }
      // }
    },
    loadArtworkLocationLogs({ commit, state }) {
      // if (localStorage.getItem('user-token')) {
      if (!state.loading_artwork_location_logs) {
        startResourceLoad(commit, 'artwork_location_logs')
        axios
          .get(`${Vue.prototype.$globals.apiserver}/artwork_location_logs.json`)
          .then(r => r.data)
          .then(ArtworkLocationLogs => {
            commit('SET_ARTWORK_LOCATION_LOGS', ArtworkLocationLogs)
            // try {
            //   localStorage.setItem('artworks', JSON.stringify(Artworks))
            // } catch (error) {
            //   console.log('VUEX ERROR!!! COULD NOT SAVE ARTWORKS TO LOCAL STORAGE')
            //   console.log(error)
            // }
            console.log('Artwork Location Logs loaded')
          })
          .catch(error => failResourceLoad(commit, 'artwork_location_logs', error))
          .then(() => finishResourceLoad(commit, 'artwork_location_logs'))
      } else {
        console.log('VUEX: ARTWORK Location Logs ALREADY LOADING')
      }
      // }
    },
    loadArtworks({ commit, state }) {
      // if (localStorage.getItem('user-token')) {
      if (!state.loading_artworks) {
        startResourceLoad(commit, 'artworks')
        axios
          .get(`${Vue.prototype.$globals.apiserver}/artworks.json`)
          .then(r => r.data) 
          // add to each artwork new atribute accession_number_for_sorting consisting of the first number in the accession_number and 
          // the number after dot with leading zeros added to the number after dot so that it always has 3 digits
          .then(Artworks => {
            Artworks.forEach(artwork => {
              const accessionNumber = artwork.accession_number ? artwork.accession_number.toString() : ''
              let accession_number_for_sorting = accessionNumber.match(/\d+/g)
              if (accession_number_for_sorting && accession_number_for_sorting.length > 0) {
                accession_number_for_sorting = accession_number_for_sorting[0] + '.' + ('000' + (accession_number_for_sorting[1] || '0')).slice(-3)
              } else {
                accession_number_for_sorting = '0.000'
              }
              artwork.accession_number_for_sorting = accession_number_for_sorting
            })
          
            commit('SET_ARTWORKS', Artworks)
            try {
              localStorage.setItem('artworks', JSON.stringify(Artworks))
            } catch (error) {
              console.log('VUEX ERROR!!! COULD NOT SAVE ARTWORKS TO LOCAL STORAGE')
              console.log(error)
            }
            console.log('Slow Artworks loaded')
          })
          .catch(error => failResourceLoad(commit, 'artworks', error))
          .then(() => finishResourceLoad(commit, 'artworks'))
      } else {
        console.log('VUEX: ARTWORKS ALREADY LOADING')
      }
      // }
    },
    loadFileUploads({ commit }) {
      startResourceLoad(commit, 'file_uploads')
      axios
        .get(`${Vue.prototype.$globals.apiserver}/file_uploads.json`)
        .then(r => r.data)
        .then(FileUploads => {
          commit('SET_FILE_UPLOADS', FileUploads)
        })
        .catch(error => failResourceLoad(commit, 'file_uploads', error))
        .then(() => finishResourceLoad(commit, 'file_uploads'))
    },
    loadUsers({ commit }) {
      startResourceLoad(commit, 'users')
      axios
        .get(`${Vue.prototype.$globals.apiserver}/users.json`)
        .then(r => r.data)
        .then(Users => {
          commit('SET_USERS', Users)
          // localStorage.setItem('users', JSON.stringify(Users))
          // console.log('Users loaded')
        })
        .catch(error => failResourceLoad(commit, 'users', error))
        .then(() => finishResourceLoad(commit, 'users'))
    },
    loadLocations({ commit }) {
      startResourceLoad(commit, 'locations')
      axios
        .get(`${Vue.prototype.$globals.apiserver}/artwork_locations.json`)
        .then(r => r.data)
        .then(Locations => {
          commit('SET_LOCATIONS', Locations)
          // localStorage.setItem('locations', JSON.stringify(Locations))
          console.log('Locations loaded')
        })
        .catch(error => failResourceLoad(commit, 'locations', error))
        .then(() => finishResourceLoad(commit, 'locations'))
    },
    loadContacts({ commit }) {
      startResourceLoad(commit, 'contacts')
      axios
        .get(`${Vue.prototype.$globals.apiserver}/contacts.json`)
        .then(r => r.data)
        .then(Contacts => {
          commit('SET_CONTACTS', Contacts)
          // localStorage.setItem('contacts', JSON.stringify(Contacts))
          console.log('Contacts loaded')
        })
        .catch(error => failResourceLoad(commit, 'contacts', error))
        .then(() => finishResourceLoad(commit, 'contacts'))
    },
    loadExhibitions({ commit }) {
      // if (localStorage.getItem('user-token')) {
      startResourceLoad(commit, 'exhibitions')
      axios
        .get(`${Vue.prototype.$globals.apiserver}/exhibitions.json`)
        // .get(`${Vue.prototype.$globals.apiserver}/exhibitions.json`)
        .then(r => r.data)
        .then(Exhibitions => {
          commit('SET_EXHIBITIONS', Exhibitions)
          // localStorage.setItem('exhibitions', JSON.stringify(Exhibitions))
          console.log('Exhibitions loaded')
        })
        .catch(error => failResourceLoad(commit, 'exhibitions', error))
        .then(() => finishResourceLoad(commit, 'exhibitions'))
      // }
    },
    loadArtists({ commit }) {
      startResourceLoad(commit, 'artists')
      axios
        .get(`${Vue.prototype.$globals.apiserver}/artists.json`)
        .then(r => r.data)
        .then(Artists => {
          commit('SET_ARTISTS', Artists)
          localStorage.setItem('artists', JSON.stringify(Artists))
          console.log('Artists loaded')
        })
        .catch(error => failResourceLoad(commit, 'artists', error))
        .then(() => finishResourceLoad(commit, 'artists'))
    },
    loadLists({ commit }) {
      startResourceLoad(commit, 'lists')
      axios
        .get(`${Vue.prototype.$globals.apiserver}/lists.json`)
        .then(r => r.data)
        .then(Lists => {
          commit('SET_LISTS', Lists)
          // localStorage.setItem('lists', JSON.stringify(Lists))
          console.log('Lists loaded')
        })
        .catch(error => failResourceLoad(commit, 'lists', error))
        .then(() => finishResourceLoad(commit, 'lists'))
    },
    loadTodos({ commit }) {
      startResourceLoad(commit, 'todos')
      axios
        .get(`${Vue.prototype.$globals.apiserver}/artwork_todos.json`)
        .then(r => r.data)
        .then(Todos => {
          commit('SET_TODOS', Todos)
          // localStorage.setItem('todos', JSON.stringify(Todos))
          console.log('Todos loaded')
        })
        .catch(error => failResourceLoad(commit, 'todos', error))
        .then(() => finishResourceLoad(commit, 'todos'))
    },
    loadTags({ commit }) {
      startResourceLoad(commit, 'tags')
      axios
        .get(`${Vue.prototype.$globals.apiserver}/tags.json`)
        .then(r => r.data)
        .then(tags => {
          commit('SET_TAGS', tags)
          // localStorage.setItem('tags', JSON.stringify(tags))
          console.log('Tags loaded')
        })
        .catch(error => failResourceLoad(commit, 'tags', error))
        .then(() => finishResourceLoad(commit, 'tags'))
    },
    loadTagCategories({ commit }) {
      startResourceLoad(commit, 'tag_categories')
      axios
        .get(`${Vue.prototype.$globals.apiserver}/tag_categories.json`)
        .then(r => r.data)
        .then(tagCategories => {
          commit('SET_TAG_CATEGORIES', tagCategories)
          // localStorage.setItem('tags', JSON.stringify(tags))
          console.log('Tag categories loaded')
        })
        .catch(error => failResourceLoad(commit, 'tag_categories', error))
        .then(() => finishResourceLoad(commit, 'tag_categories'))
    },
    loadTexts({ commit }) {
      if (localStorage.getItem('user-token')) {
        startResourceLoad(commit, 'texts')
        axios
          .get(`${Vue.prototype.$globals.apiserver}/artwork_texts.json`)
          // .get(`${Vue.prototype.$globals.apiserver}/artwork_texts.json`)
          .then(r => r.data)
          .then(texts => {
            commit('SET_TEXTS', texts)
            // localStorage.setItem('texts', JSON.stringify(texts))
            console.log('Texts loaded')
          })
          .catch(error => failResourceLoad(commit, 'texts', error))
          .then(() => finishResourceLoad(commit, 'texts'))
      }
    },
    loadPackings({ commit }) {
      startResourceLoad(commit, 'packings')
      axios
        .get(`${Vue.prototype.$globals.apiserver}/artwork_packings.json`)
        .then(r => r.data)
        .then(packings => {
          commit('SET_PACKINGS', packings)
          // localStorage.setItem('packings', JSON.stringify(packings))
          console.log('Packings loaded')
        })
        .catch(error => failResourceLoad(commit, 'packings', error))
        .then(() => finishResourceLoad(commit, 'packings'))
    },
    loadSupportArticles({ commit }) {
      startResourceLoad(commit, 'support_articles')
      axios
        .get(`${Vue.prototype.$globals.apiserver}/support_articles.json`)
        .then(r => r.data)
        .then(supportArticles => {
          commit('SET_SUPPORT_ARTICLES', supportArticles)
          localStorage.setItem(
            'support_articles',
            JSON.stringify(supportArticles)
          )
          console.log('Support Articles loaded')
          // console.log(supportArticles)
        })
        .catch(error => failResourceLoad(commit, 'support_articles', error))
        .then(() => finishResourceLoad(commit, 'support_articles'))
    },
    loadJournals({ commit }) {
      startResourceLoad(commit, 'journals')
      axios
        .get(`${Vue.prototype.$globals.apiserver}/journals.json`)
        .then(r => r.data)
        .then(Journals => {
          commit('SET_JOURNALS', Journals)
          // localStorage.setItem('journals', JSON.stringify(Journals))
          console.log('Journals loaded')
        })
        .catch(error => failResourceLoad(commit, 'journals', error))
        .then(() => finishResourceLoad(commit, 'journals'))
    },
    loadQuestions({ commit }) {
      startResourceLoad(commit, 'questions')
      axios
        .get(`${Vue.prototype.$globals.apiserver}/questions.json`)
        .then(r => r.data)
        .then(Questions => {
          commit('SET_QUESTIONS', Questions)
          // localStorage.setItem('questions', JSON.stringify(Questions))
          console.log('Questions loaded')
        })
        .catch(error => failResourceLoad(commit, 'questions', error))
        .then(() => finishResourceLoad(commit, 'questions'))
    }
  },
  getters: {
    formattedTags: state => {
      // console.log(this.$store.getters.conceptual_tags.length);
      // console.log(this.$store.getters.cataloguing_tags.length);
      console.log('-----------')
      console.log(state.user_id)
      console.log('-----------')
      var tags = state.tags.filter(t => t.section == 'cataloguing' || t.section == 'concept' || (t.section == 'private'|| t.section == 'custom' && t.created_by == state.user_id)).sort((a, b) => a.subcategory.localeCompare(b.subcategory))
      // var con_tags = state.getters.conceptual_tags.sort((a, b) => a.subcategory.localeCompare(b.subcategory))
          .map((tag) => ({
              label: `${tag.subcategory} #${tag.name}`,
              subcategory: tag.subcategory,
              section: tag.section,
              name: tag.name,
              id: tag.id,
          }));
      // var cat_tags = state.getters.cataloguing_tags.sort((a, b) => a.subcategory.localeCompare(b.subcategory))
      //     .map((tag) => ({
      //         label: `${tag.subcategory} #${tag.name}`,
      //         name: tag.name,
      //         id: tag.id,
      //     }));
      // return con_tags.concat(cat_tags).sort((a, b) => a.name.localeCompare(b.name));
      return tags
    },

    tagNames: state => {
      return state.tags.map(tag => `${tag.section} - ${tag.subcategory} #${tag.name}`).filter(name => name !== null);
    },
    cataloguing_tags: state => {
      return state.tags.filter(t => t.section == 'cataloguing').sort()
    },
    cataloguing_tag_subcategories: state => {
      // return unique subcategories of tags in section "cataloguing"
      var array = Object.assign([], state.tags.filter(t => t.section == 'cataloguing'))
      var unique = [];
      var distinct = [];
      for ( let i = 0; i < array.length; i++ ) {
          if ( !unique[array[i].subcategory]) {
              if (array[i].subcategory != null) {
                  distinct.push({ subcategory: array[i].subcategory, section: array[i].section });
                  unique[array[i].subcategory] = 1;
              }
          }
      }
      return distinct.sort()
      // return state.tags.filter(t => t.section == 'concept' && t.concept_tag == 1).sort()
      // return state.tags.filter(t => t.section == 'cataloguing' && t.subcategory == t.name).sort()
    },
    conceptual_tags: state => {
      return state.tags.filter(t => t.section == 'concept').sort()
    },
    conceptual_tag_categories: state => {
      // return state.tags.filter(t => t.section == 'concept' && t.concept_tag == 1).sort()
      return state.tags.filter(t => t.section == 'concept' && t.subcategory == t.name).sort()
    },
    // conceptual_tag_categories: state => {
    //   var array = Object.assign([], this.conceptual_tags)
    //   var unique = [];
    //   var distinct = [];
    //   for ( let i = 0; i < array.length; i++ ) {
    //       if ( !unique[array[i].category]) {
    //           if (array[i].category != null) {
    //               distinct.push({ category: array[i].category, section: array[i].section });
    //               unique[array[i].category] = 1;
    //           }
    //       }
    //   }
    //   return distinct.sort()
    // },
    tag_categories: state => {
      var array = Object.assign([], state.tags)
      var unique = [];
      var distinct = [];
      for (let i = 0; i < array.length; i++) {
        if (!unique[array[i].category]) {
          if (array[i].category != null) {
            distinct.push({ category: array[i].category, section: array[i].section });
            unique[array[i].category] = 1;
          }
        }
      }
      return distinct.sort()
    },
    tag_sections: state => {
      var array = Object.assign([], state.tags.filter(t => t.section != 'concept'))
      var unique = [];
      var distinct = [];
      for (let i = 0; i < array.length; i++) {
        if (!unique[array[i].section]) {
          if (array[i].section != null) {
            distinct.push(array[i].section);
            unique[array[i].section] = 1;
          }
        }
      }
      return distinct.sort()
    },
    tag_sections_relation: state => {
      var array = Object.assign([], state.tags.filter(t => t.section == 'exhibition'))
      var unique = [];
      var distinct = [];
      for (let i = 0; i < array.length; i++) {
        if (!unique[array[i].section]) {
          if (array[i].section != null) {
            distinct.push(array[i].section);
            unique[array[i].section] = 1;
          }
        }
      }
      return distinct.sort()
    },
    locationsSorted: state => {
      return Object.assign([], state.locations)
        .filter(location => location.disabled != 1)
        .sort(dynamicSort('name'))
    },
    current_locations: state => {
      return state.locations.filter(l =>
        l.disabled != 1 && (l.id > 458 || l.id < 233 || l.id === 237 || l.id === 273)
      )
    },
    enabled_locations: state => {
      return state.locations.filter(l => l.disabled != 1)
    },
    my_ownerships: state => {
      if (state.user.profile.roles) {
        return constants.OWNERSHIPS.filter(o => state.user.profile.roles.find(ur => ur.shortcut === o.role))
      } else {
        return [] // 'no user roles'
      }
    },
    // isAuthenticated: state => !!state.token,
    // authStatus: state => state.status,
    // texts: state => {
    //   return state.texts
    // },
    loading: state => {
      return (
        state.loading_artworks ||
        state.loading_rules ||
        state.loading_artists ||
        state.loading_contacts ||
        state.loading_users ||
        state.loading_lists ||
        state.loading_locations ||
        state.loading_exhibitions ||
        state.loading_packings ||
        state.loading_texts ||
        state.loading_tags ||
        state.loading_tag_categories ||
        state.loading_todos ||
        state.loading_journals ||
        state.loading_support_articles ||
        state.loading_questions
      )
    },
    loans: state => {
      return state.exhibitions.filter(a => a.loan === 1)
    },
    exhibitions: state => {
      return state.exhibitions.filter(a => a.loan !== 1)
    },
    paintings: state => {
      return state.artworks.filter(a => a.classification_new_id === 2)
    },
    drawings: state => {
      return state.artworks.filter(a => a.classification_new_id === 1)
    },
    videos: state => {
      return state.artworks.filter(a => a.classification_new_id === 7)
    },
    sound: state => {
      return state.artworks.filter(a => a.classification_new_id === 9)
    },
    objectsAndSculptures: state => {
      return state.artworks.filter(a => a.classification_new_id === 4)
    },
    // sculptures: state => {
    //   return state.artworks.filter(a => a.classification_new_id === 4)
    // },
    photographs: state => {
      return state.artworks.filter(a => a.classification_new_id === 3)
    },
    collection: state => {
      return state.artworks.filter(
        a => a.classification_new_id > 0 && a.classification_new_id < 10
      )
    },
    artistsYoung: state => {
      return state.artists.filter(a => getAge(a.birth_date) < 31)
    },
    artistsMid: state => {
      return state.artists.filter(
        a => getAge(a.birth_date) > 30 && getAge(a.birth_date) < 51
      )
    },
    artistsOld: state => {
      return state.artists.filter(a => getAge(a.birth_date) > 50)
    },
    user_lists: state => {
      const userId = (state.user && state.user.profile && state.user.profile.id) || state.profile.id
      return state.lists.filter(l => l.created_by === userId)
    },
    user_todos: state => {
      const userId = (state.user && state.user.profile && state.user.profile.id) || state.profile.id
      return state.todos.filter(l => l.created_by === userId)
    }
  },
  modules: {
    user,
    auth
  },
  strict: debug
  // plugins: debug ? [createLogger()] : []
})
    // types_of_work: [
    //   // THIS IS AS IN THE TABLE ARTWORK_TYPES
    //   { id: 1, value: 1, name: 'Drawing' },
    //   { id: 2, value: 2, name: 'Painting' },
    //   { id: 3, value: 3, name: 'Photo / Print' },
    //   { id: 5, value: 5, name: 'Architecture' },
    //   { id: 4, value: 4, name: 'Object / Sculpture' },
    //   { id: 10, value: 10, name: 'Furniture' },
    //   { id: 6, value: 6, name: 'Installation' },
    //   { id: 7, value: 7, name: 'Film / Video' },
    //   { id: 9, value: 9, name: 'Sound' },
    //   { id: 8, value: 8, name: 'Performance' },
    //   { id: 11, value: 11, name: 'Concept' },
    //   { id: 12, value: 12, name: 'Metalworks' },
    //   { id: 13, value: 13, name: 'Vertu' },
    //   { id: 14, value: 14, name: 'Oriental' },
    //   { id: 15, value: 15, name: 'Silverware' },
    //   { id: 17, value: 17, name: 'Jewellery' },
    //   { id: 16, value: 16, name: 'Textiles' },
    //   { id: 18, value: 18, name: 'Collage' }
    // ],

// import CommonMixin from './../mixins/CommonMixin.js'
// Vue.mixin(CommonMixin)
// import * as actions from './actions'
// import * as getters from './getters'
// import list from './modules/list'
// import users from './modules/users/users.module'

// function dynamicSort (property) {
//   var sortOrder = 1
//   if (property[0] === '-') {
//     sortOrder = -1
//     property = property.substr(1)
//   }
//   return function (a, b) {
//     var result =
//       a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0
//     return result * sortOrder
//   }
// }

// function humanize (str) {
//   var frags = str.split('_')
//   for (let i = 0; i < frags.length; i++) {
//     frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1)
//   }
//   return frags.join(' ')
// }
// tag_categories: [
//   { id: 1, name: 'TBA21 Exhibition', color: 'red', position: 2 },
//   { id: 2, name: 'TBA21 Production', color: 'green', position: 3 },
//   { id: 3, name: 'FTB Sorting', color: 'blue', position: 1 },
//   { id: 4, name: 'TBA21 Projects', color: 'yellow', position: 4 },
//   { id: 5, name: 'TBA21 Events', color: 'pink', position: 5 },
//   { id: 6, name: 'Exhibitions', color: 'grey', position: 6 },
//   { id: 7, name: 'Institutions', color: 'purple', position: 7 }
// ],



// WEBPACK FOOTER //
// ./src/store/index.js